<template>
<div>
    <v-container>
    <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
        <v-toolbar flat class="mt-7">
            <v-btn large class="my-2 mr-2" :text="disabledActive" @click="active()">ACTIVE</v-btn>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-btn large class="ma-2" :text="disabledPrev" @click="previous()">PREVIOUS</v-btn>
            <v-spacer class="hidden-sm-and-down"></v-spacer>
             <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="width:20%"
                class="hidden-sm-and-down"
            ></v-text-field>
        </v-toolbar>
        <v-system-bar color="white">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Search"
                single-line
                hide-details
                style="width:20%"
                class="hidden-md-and-up"
            ></v-text-field>
        </v-system-bar>
        <v-card class="my-5">
            <!-- claims -->
        <template>
            <v-data-table
            :headers="orderHeaders"
            :items="orders"
            :class="elevation-1"
            class=""
            :search="search"
            no-data-text="You don't have any order"
            hide-default-footer
            >
            <template v-slot:item.items="{ item }"> 
                <v-badge class="mt-3" color="red" overlap left bordered="true">
                    <template v-slot:badge>
                        <span class="">{{item.noOfItems}}</span>
                    </template>
                    <!-- <v-img :src="item.items" height="100px" width="100px" contain class="" style="border:1px grey solid"></v-img> -->
                    <v-carousel  hide-delimiters height="120" show-arrows-on-hover>
                        <v-carousel-item v-for="img in item.imgUrl" :key="img" :src="img.imgUrl" reverse-transition="fade-transition" transition="fade-transition"   style="border:1px grey solid" width="200" contain></v-carousel-item>
                    </v-carousel>
                </v-badge> 
            </template>
            <template v-slot:item.user="{ item }" > 
                <span v-if="item.status!=='Pending'">{{item.username}}</span>
                <span class="d-block" v-if="item.amazonOrder!==null">{{item.amazonOrder}}</span>
            </template>
            <!-- <template v-slot:item.totalPay="{ item }" v-if="userId===ite"
                {{item.totalPay.toFixed(2)}} 
                <span class="d-block green--text">Saving ${{item.savedFee.toFixed(2)}} ({{item.savedFeePercent.toFixed(2)}}%)</span>
            </template> -->
            <template v-slot:item.totalPay="{ item }"> 
                <span v-if="userId===item.shopperId">{{item.totalPay.toFixed(2)}}</span> 
                <span v-if="userId===item.earnerId">{{item.priceEarner.toFixed(2)}}</span> 
                <span class="d-block green--text">Saving ${{item.savedFee.toFixed(2)}} ({{item.discount}}%)</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    style="color:green; cursor: pointer;"
                    
                        @click="getOrderById(item.id)"
                    >
                    mdi-chevron-right
                </v-icon>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip color="green" small dark>{{ item.status }}</v-chip>
                <v-badge class="ml-1" color="red" bordered="true" v-if="item.messageCount>0">
                    <template v-slot:badge>
                        <span class="">{{item.messageCount}}</span>
                    </template>
                    
                </v-badge>
            </template>
            
            <!-- <template v-slot:body="{ items }"> -->
                <!-- <tbody> -->
                    <!-- <tr :class="key === selectedRow ? 'custom-highlight-row' : ''" @click="rowSelect(key)" v-for="(item, key) in items" :key="item.name"> -->
                    <!-- <tr  v-for="(item) in items" :key="item.name" class="custom-highlight-row"> -->
                        <!-- <td> -->
                            <!-- <v-img :src="item.items" height="100px" width="100px" contain></v-img> -->
                            <!-- {{ item.items }} -->
                            <!-- <v-badge class="mr-3" color="red" overlap right dot="true" bordered="true">
                                <template v-slot:badge>
                                    <span class="ma-0 pa-0">1</span>
                                </template>
                                
                            </v-badge> -->
                        <!-- </td> -->
                        <!-- <td>{{ item.orderDate }}</td>
                        <td>
                            {{ item.deliveryDate }}
                            <v-subheader>123-567-9878</v-subheader>
                        </td>
                        <td>{{ item.user }}</td>
                        <td>
                            {{ item.total }}
                            <v-subheader class="green--text">Saving $0.77(7%)</v-subheader>
                        </td>
                        <td>
                            <v-chip color="green" small>{{ item.status }}</v-chip>
                        </td>
                        <td>
                            <v-badge class="mr-3" color="red" overlap right bordered="true">
                                <template v-slot:badge>
                                    <span class="ma-0 pa-0">{{item.messageNum}}</span>
                                </template> -->
                                <!-- <v-btn class="" small flat icon router-link to="/notifications">
                                    <v-icon>mdi-bell</v-icon>
                                </v-btn> -->
                            <!-- </v-badge>
                        </td> -->
                    <!-- </tr> -->
                <!-- </tbody> -->
            <!-- </template> -->
            </v-data-table>
        </template>
        </v-card>
        
    </v-container>

</div>
   
</template>
<script>

    export default {
        name: 'Orders',
        components: {
        },

        data(){ return{
            search:'',
            userId: this.$store.state.auth.logindetails.id,
            selectedRow: null,
            orderHeaders: [
                {
                    text: 'ITEMS',
                    align: 'left',
                    sortable: false,
                    value: 'items',
                    class:'font-weight-black'
                },
                {text: 'ORDERED', value:'orderDate', sortable:false},
                {text: 'DELIVERY', value:'deliveryDate', sortable:false},
                {text: 'EARNER', value:'user', sortable:false, align:'center'},
                {text: 'TOTAL', value:'totalPay', sortable:false, align:'center'},
                {text: 'STATUS', value:'status', sortable:false},
                { text: '', value: 'msg', sortable: false },
                { text: '', value: 'action', sortable: false },
            ],
            // orders:[
            //     {items:"/serverdown.png", orderDate:'02-02-2020', deliveryDate:'09-09-2020', user:'Ebony', total:'69.78', status:'Shipped', messageNum:'3'}
            // ],
            disabledActive:false,
            disabledPrev:false,
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
        }},
        computed:{
            orders(){
                let orders= this.$store.state.order.Orders
                for(let j=0; j<orders.length; j++){
                    if (orders[j].orderDate){
                        orders[j].orderDate= orders[j].orderDate.slice(0, 19).replace('T', ' ');
                        // orders[j].deliveryDate= orders[j].deliveryDate.slice(0, 19).replace('T', ' ');
                
                    }else{
                        orders[j].orderDate = '--:--'
                    }
                    if (orders[j].deliveryDate){
                        // orders[j].orderDate= orders[j].orderDate.slice(0, 19).replace('T', ' ');
                        orders[j].deliveryDate= orders[j].deliveryDate.slice(0, 19).replace('T', ' ');
                
                    }else{
                        orders[j].deliveryDate = '--:--'
                    }
                    // if (orders[j].username===null || orders[j].username===""){
                    //     orders[j].username= 
                    // }
                }
                return orders
            }
        }, 
        created(){
            const userLogged= this.$store.state.auth.isUserLogged
            const userVerified = this.$store.state.auth.logindetails.isVerified
            if(userLogged===true&&userVerified===0){
                this.snackbarVerify=true
            }
            this.$store.dispatch("GetOrders", {
                "type":'Active'
            })
            .then((success)=>{
                console.log(success);
            })
            .catch((error)=>{
                console.log(error);
            });
            this.disabledPrev = true
        },
        methods:{
            rowSelect(idx) {
                console.dir(idx)
                this.selectedRow = idx;
            },
            active(){
                this.disabledPrev = true
                this.disabledActive = false
                this.$store.dispatch("GetOrders", {
                    "type":'Active'
                })
                .then((success)=>{
                    console.log(success);
                })
                .catch((error)=>{
                    console.log(error);
                });
            },
            previous(){
                this.disabledActive = true
                this.disabledPrev = false
                this.$store.dispatch("GetOrders", {
                    "type":'Previous'
                })
                .then((success)=>{
                    console.log(success);
                })
                .catch((error)=>{
                    console.log(error);
                });
            },
            getOrderById(id){
                this.$store.dispatch("GetOrderById",id)
                .then((success)=>{
                    console.log(success);
                    this.$router.push('/orders/'+id)
                })
                .catch((error)=>{
                    console.log(error);
                });
                
            },
            getPercent(total, saved){
                console.log(total, saved)
                return 8
            }
        }
    }
</script>

<style scoped>
   
</style>